import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { Header as Head, Cell, Button, Group, Spacing, FormItem, Input, Caption, Checkbox, View, Panel } from '@vkontakte/vkui';
import baseTheme from '@vkontakte/vkui-tokens/themes/vkBase';
import { Selector } from 'antd-mobile'
import TinkoffForm from '../TinkoffForm';
import { Icon20InfoCircleOutline, Icon20ArticleOutline, Icon20PaymentCardOutline, Icon16DownloadOutline, Icon16CancelCircleOutline, Icon20DocumentListOutline, Icon20MoneyCircleOutline, } from '@vkontakte/icons';

const tg = window.Telegram.WebApp;

const ERRORS_MAP = {
    empty: 'Пожалуйста, введите электронную почту',
    incorrect: 'Электронная почта некорректна',
};

const validateEmail = (email) => {
    return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

const PayPage = ({ activePanel, setActivePanel, openError, userInfo, snackbar, postsBalance, activeView, setActiveView, cashlessPsc, setCashlessPsc, cashlessPdf, setCashlessPdf, isMobile }) => {
    const [paidButton, setPaidButton] = useState('Купить 50 постов');
    const [plans, setPlans] = useState([]);
    const [postsAmount, setPostsAmount] = useState(50);
    const [paidAmount, setPaidAmount] = useState(3000);
    const [cashless, setCashless] = useState(null);
    const [payLoading, setPayLoading] = useState(null);
    const [cashlessInn, setCashlessInn] = useState('');
    const [cashlessInvoice, setCashlessInvoice] = useState('');
    const [cashlessEmail, setCashlessEmail] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [cashlessList, setCashlessList] = useState([]);
    const [payMethod, setPayMethod] = useState('1');
    const [postsSelect, setPostsSelect] = useState(0);

    const updateEmail = (value) => {
        setEmail(value);
        if (!value) {
            setEmailError('empty');
        } else if (!validateEmail(value)) {
            setEmailError('incorrect');
        } else {
            setEmailError('');
        }
    };

    const setStateActionsMap = {
        email: updateEmail
    };

    const onChange = (e) => {
        const { name, value } = e.currentTarget;
        const setStateAction = setStateActionsMap[name];
        setStateAction && setStateAction(value);
    };

    const onSelectChange = (name, newValue) => {
        const setStateAction = setStateActionsMap[name];
        setStateAction && setStateAction(newValue);
    };

    const handleInnChange = (event) => {
        const value = event.target.value.replace(/\D/g, '');
        setCashlessInn(value);
    };

    const handleBackClick = () => {
        window.history.go(-1);
    };

    const handleEmailChange = (event) => {
        const value = event.target.value;
        setEmail(value);
    };

    const handleCheckboxEmail = (event) => {
        setCashlessEmail(event.target.checked);
    };

    const cancelBill = (invoice) => {
        // Формирование объекта с данными
        const dataToSend = {
            invoice_id: invoice
        };

        // URL API
        const apiUrl = 'https://api.gmpapp.ru/cancel_bill';

        // Отправка данных
        axios.post(apiUrl, dataToSend)
            .then((response) => {
                tg.showAlert("Платёж был успешно отменён");
                getCashless();
            })
            .catch((error) => {
                console.error('Ошибка при отправке данных', error);
            });
    }

    const getCashless = async () => {
        const url = `https://api.gmpapp.ru/get_cashless?tg_id=${tg.initDataUnsafe.user.id}`;

        try {
            const response = await fetch(url);
            const data = await response.json();
            setCashlessList(data.items);
        } catch (error) {
            console.error('Error while fetching cashless list:', error);
        }
    };

    const cancelPay = (invoice) => {
        tg.showPopup({
            title: "Отмена платежа",
            message: "Вы действительно хотите отменить платёж?",
            buttons: [
                { id: 'ok', text: 'Отменить платёж', type: 'destructive' },
                { id: 'cancel', type: 'cancel' },
            ]
        }, (buttonId) => {
            if (buttonId === 'cancel') {
                console.log("Действие отменено");
            } else if (buttonId === 'ok') {
                cancelBill(invoice);
            }
        });
    };

    const paymentMethod = () => {
        if (!cashless) {
            tg.showPopup({
                title: "Оплата",
                message: "Вы покидаете сервис и переходите к оплате выбранного пакета постов. Если вы передумаете на странице оплаты, то необходимо будет заново войти в сервис",
                buttons: [
                    { id: 'ok', text: 'Оплатить' },
                    { id: 'cancel', type: 'destructive', text: 'Отмена' },
                ]
            }, (buttonId) => {
                if (buttonId === 'cancel') {
                    console.log("Действие отменено");
                } else if (buttonId === 'ok') {
                    tg.BackButton.hide();
                    const tinkoffBtn = document.querySelector('.payform-tinkoff-btn');
                    tinkoffBtn.click();
                }
            });
        } else {
            setPayLoading(true);
            const getChannels = async () => {
                if (cashlessInn === '') {
                    openError("Введите ИНН или выберите оплату картой");
                    setPayLoading(false);
                    return;
                }

                axios.post('https://api.gmpapp.ru/cashless_pay', {
                    tg_id: window.Telegram.WebApp.initDataUnsafe.user.id,
                    inn: cashlessInn,
                    psc: plans.find(plan => plan.id === postsSelect)?.amount,
                    email: email
                })
                    .then(response => {
                        setPayLoading(false);
                        const backButtonHandler = () => {
                            tg.HapticFeedback.impactOccurred('heavy');
                            tg.HapticFeedback.notificationOccurred("success");
                            setActiveView('payment');
                            tg.BackButton.offClick(backButtonHandler);
                        };

                        tg.BackButton.onClick(backButtonHandler);

                        setCashlessPsc(plans.find(plan => plan.id === postsSelect)?.amount);
                        setCashlessPdf(response.data.pdf);
                        setActiveView('paysuccess');
                    })
                    .catch(error => {
                        setPayLoading(false);
                        if (error.response) {
                            // Проверяем статус ошибки
                            if (error.response.status === 422) {
                                openError("Email введён некорректно");
                            } else if (error.response.status === 400) {
                                openError("ИНН введён неверно");
                            } else {
                                openError("Произошла ошибка, попробуйте еще раз");
                            }
                        } else {
                            // Если ошибка без ответа от сервера
                            openError("Произошла ошибка, попробуйте еще раз");
                        }
                    });
            };
            getChannels();
        }
    };

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('home');
        };

        if (activePanel === 'payment') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    useEffect(() => {
        const getPlans = async () => {
            const url = `https://api.gmpapp.ru/get_plans`;

            try {
                const response = await fetch(url);
                const data = await response.json();
                setPlans(data.items);

                if (data.items.length > 0) {
                    setPostsSelect(data.items[0].id); // Устанавливаем id первого плана как начальное значение
                }
            } catch (error) {
                console.error('Error while fetching plans list:', error);
            }
        };

        getPlans();
    }, []);

    useEffect(() => {
        const getCashless = async () => {
            const url = `https://api.gmpapp.ru/get_cashless?tg_id=${tg.initDataUnsafe.user.id}`;

            try {
                const response = await fetch(url);
                const data = await response.json();
                setCashlessList(data.items);
            } catch (error) {
                console.error('Error while fetching cashless list:', error);
            }
        };

        getCashless();
    }, []);

    return (
        <div className="wrapperUI">
            <Group className="paymentView" style={{ textAlign: "center", marginTop: isMobile ? "var(--tg-content-safe-area-inset-top)" : undefined }} >
                {cashlessList.length > 0 && (
                    <Head mode="tertiary">Счета на оплату</Head>
                )}
                {cashlessList.map((cashlessItem) => (
                    <Cell
                        after={
                            <>
                                <Button onClick={() => window.open(cashlessItem.pdf)} after={<Icon16DownloadOutline />}>
                                    Счёт
                                </Button>
                                <Button style={{ marginLeft: "6px" }} onClick={() => cancelPay(cashlessItem.invoice)} appearance="negative" after={<Icon16CancelCircleOutline />}></Button>
                            </>
                        }
                        subtitle={`${cashlessItem.posts} постов | ${cashlessItem.date}`}
                    >
                        Заказ #{cashlessItem.invoice}
                    </Cell>
                ))}
                <Cell before={<Icon20ArticleOutline />} after={postsBalance}>Доступно постов:</Cell>
                <Head mode="tertiary">Способ оплаты</Head>
                <Selector
                    className='payMethod'
                    columns={2}
                    value={[payMethod]}
                    options={[
                        {
                            label: <Icon20PaymentCardOutline />,
                            description: 'Картой онлайн',
                            value: '1',
                        },
                        {
                            label: <Icon20ArticleOutline />,
                            description: 'Безналичный расчёт',
                            value: '2',
                        },
                    ]}
                    onChange={v => {
                        if (v.length) {
                            const selectedValue = v[0]; // Получаем первое значение из массива
                            setPayMethod(selectedValue); // Устанавливаем метод оплаты

                            // Устанавливаем cashless в зависимости от выбранного значения
                            if (selectedValue === '1') {
                                setCashless(false);
                            } else if (selectedValue === '2') {
                                setCashless(true);
                            }
                        }
                    }}

                />
                {snackbar}
                {cashless && (
                    <FormItem htmlFor="inn" top={(<div>ИНН<a style={{ color: "#cd3f3f" }}>*</a></div>)} style={{ textAlign: "left", padding: "0 12px", paddingTop: "10px" }}>
                        <Input id="inn" value={cashlessInn} onChange={handleInnChange} inputMode="numeric" pattern="[0-9]*" />
                        <Caption level="1" style={{ marginTop: 6, marginBottom: 10, lineHeight: 'normal' }}>
                            ВАЖНО: Указанный ИНН должен точно соответствовать ИНН плательщика, с которого будет осуществляться платеж
                        </Caption>
                        <FormItem
                            htmlFor="email"
                            top="E-mail для копии счёта"
                            status={emailError ? 'error' : ''}
                            bottom={emailError ? ERRORS_MAP[emailError] : ''}
                            bottomId="email-type"
                            required
                        >
                            <Input
                                aria-labelledby="email-type"
                                id="email"
                                type="email"
                                name="email"
                                value={email}
                                required
                                onChange={onChange}
                            />
                        </FormItem>
                    </FormItem>
                )}
                <Head mode="tertiary">Купить</Head>
                <Selector
                    className='postsSelect'
                    columns={plans.length}
                    value={[postsSelect]}
                    options={plans.map(plan => ({
                        label: <span><span>{plan.amount}</span><br />постов</span>,
                        description: `${(cashless ? plan.cashless_price : plan.price).toLocaleString('ru-RU')}₽`,
                        value: plan.id,
                    }))}
                    onChange={v => {
                        if (v.length) {
                            const selectedValue = v[0]; // Получаем первое значение из массива
                            setPostsSelect(selectedValue); // Устанавливаем метод оплаты
                            console.log(v)
                        }
                    }}
                />
                <Spacing size={16} />
                <Button
                    className="paymentBtn"
                    loading={payLoading}
                    style={{ fontFamily: "VK Sans Display", width: "100%", fontSize: "14px", fontWeight: "500", color: baseTheme.colorTextContrast.normal, border: "none", borderRadius: "10px", backgroundColor: baseTheme.colorAccentBlue.normal, height: "52px", marginBottom: "6px" }}
                    onClick={paymentMethod}
                >
                    Купить {plans.find(plan => plan.id === postsSelect)?.amount} постов
                </Button>
                <Group className="paymentTink">
                    <TinkoffForm
                        amount={plans.find(plan => plan.id === postsSelect)?.price}
                        name={`${userInfo.first_name}|${userInfo.last_name}`}
                        phone={tg.initDataUnsafe.user.id}
                        button={paidButton}
                        data={`tg_id=${tg.initDataUnsafe.user.id}|postsAmount=${cashlessPsc}`}
                    />
                </Group>
            </Group>
        </div>
    );
};

export default PayPage;
